import styled, { css } from "styled-components";

export const StyledMessageEditorTitle = styled.div`
    border-bottom: 1px solid var(--ds-color-silver);
    padding: 0.5rem;
    display: flex;
    align-items: center;

    margin-inline: -0.5rem;
`;

export const StyledMessageEditorContainer = styled.div<{
    $hasVisualBox: boolean;
}>`
    display: flex;
    gap: 1rem;
    flex-direction: column;

    ${({ $hasVisualBox }) =>
        $hasVisualBox &&
        css`
            border-radius: var(--ds-border-radius);
            border: 1px solid var(--ds-color-silver);
            padding: 1rem 0.5rem;
        `}

    &:has(${StyledMessageEditorTitle}) {
        padding-top: 0;
    }
`;
